<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-12-15 19:57:06
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-12-20 17:14:57
-->
<template>
  <div class="innovative intracardiac" :class="{textj: language != 'en'}">
    <div class="innovative-bj scrollBox">
      <img class="wid100" :src="require(`@/assets/images/m/innovate${language == 'en' ? '/en' : ''}/heart_bj.png`)" alt="" srcset="">
      <div v-if="language != 'en'" class="innovative-bj-txt" @click="$router.push({ path: language == 'en' ? '/en/guidance' :'/guidance' })"></div>
    </div>
    <!-- <div :class="language != 'en' ? 'innovative-container p-t-48' : ''"> -->
    <div class="innovative-container">
      <img @contextmenu="($event) => {$event.returnValue = false; return false}" @dragstart.prevent class="wid100" :src="$t('product.heart.m_processImg')" alt="" srcset="">
    </div>
    <div>
      <div class="innovative-container">
        <div class="innovative-wrap-item-title color_active" :class="{ textc: language == 'zh' }" v-html="$t('product.heart.intelligence.title')"></div>
        <div class="textj" v-html="$t('product.heart.intelligence.des')"></div>
      </div>
      <div>
        <img class="wid100" :src="$t('product.heart.intelligence.m_img')" alt="" srcset="">
      </div>
    </div>
    <div class="innovative-container">
      <div class="innovative-advantages p-t-5">
        <div class="innovative-wrap-item-title color_active p-b-24 textc">{{$t('product.heart.coreAdvantages.title')}}</div>
        <div class="innovative-advantages-box">
          <div class="innovative-advantages-item flex" v-for="item, index in $t('product.heart.coreAdvantages.list')" :key="index">
            <div class="p-t-12 textc innovative-advantages-item-box" :class="{en: language == 'en'}">
              <img class="innovative-advantages-item-img" :src="item.img" alt="" srcset="">
              <div class="innovative-advantages-item-title">{{item.title}}</div>
            </div>
            <div class="flex_1">
              <div class="p-l-50">
                <p v-for="$item, $index in item.des" :key="$index" v-html="$item"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="innovative-products innovative-wrap-item">
      <div class="innovative-wrap-item-title textc color_active p-b-50">{{$t('product.heart.relatedProducts.title')}}</div>
      <div class="swiper-container swiper1">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in $t('product.heart.relatedProducts.list')" :key="index">
            <div :class="['innovative-products-item', item.disabled ? 'disabled' : 'cursor_pointer']" :data-path="item.path" :data-disabled="item.disabled">
              <div class="innovative-products-mask flex justify_content_center align_items_center" v-if="item.disabled"><span class="txt">敬请期待</span></div>
              <img class="wid100" :src="item.img" alt="" srcset="">
              <div class="innovative-products-item-title ellipsis" v-html="item.title"></div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination swiper1-pagination"></div>
      </div>
    </div>
    <div class="innovative-intelligence innovative-wrap-item p-b-10">
      <div class="innovative-wrap-item-title textc color_active p-b-60" v-html="$t('product.heart.structureFunction.title')"></div>
      <div class="innovative-intelligence-imgbox flex justify_content_center align_items_center">
        <img class="innovative-intelligence-img" :src="$t('product.heart.structureFunction.img')" alt="" srcset="">
        <img class="innovative-intelligence-rotate" :src="$t('product.heart.structureFunction.bjImg')" alt="" srcset="">
      </div>
      <div class="innovative-container textj">
        <div class="p-t-90">{{$t('product.heart.structureFunction.des')}}</div>
      </div>
    </div>
    <div class="p-t-0" :class="language == 'en' ? 'p-l-10 p-r-10' : 'innovative-container'">
      <div class="innovative-structureFunction">
        <img class="innovative-structureFunction-img" :src="$t('product.heart.structureFunction.summary.imgM')" alt="" srcset="">
        <img class="innovative-structureFunction-rotate" :src="$t('product.heart.structureFunction.summary.bjImg')" alt="" srcset="">
      </div>
      <div class="innovative-products p-t-36">
        <div class="innovative-products-title textc p-b-36 color_active">{{$t('product.skull.narrow.products.title')}}</div>
        <div class="swiper-container swiper2">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item,index) in $t('product.heart.structureFunction.products.list')" :key="index">
              <div :class="['innovative-products-item', item.disabled ? 'disabled' : 'cursor_pointer']" :data-path="item.path" :data-disabled="item.disabled">
                <div class="innovative-products-mask flex justify_content_center align_items_center" v-if="item.disabled"><span class="txt">敬请期待</span></div>
                <img class="wid100" :src="item.img" alt="" srcset="">
                <div class="innovative-products-item-title ellipsis" v-html="item.title"></div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination swiper2-pagination"></div>
        </div>
      </div>
    </div>
    <div class="p-t-40">
      <img class="wid100" :src="$t('product.heart.significance.imgM')" alt="" srcset="">
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  created () {
  },
  mounted () {
    this.$nextTick(() => {
      this.mySwiper1 = this.initSwiper('.swiper1')
      this.mySwiper2 = this.initSwiper('.swiper2')
    })
  },
  methods: {
    initSwiper (el) {
      return new this.$Swiper(el, {
        // 循环
        loop: true,
        // 每张播放时长3秒，自动播放
        spaceBetween: 16,
        // 切换效果
        effect: 'coverflow',
        // 该选项给Swiper用户提供小小的贴心应用，设置为true时，鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状。
        grabCursor: true,
        // 设定为true时，active slide会居中，而不是默认状态下的居左。
        centeredSlides: true,
        // 设置slider容器能够同时显示的slides数量(carousel模式)。
        slidesPerView: 1.2,
        // 启动动态检查器(OB/观众/观看者)，当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper。默认false，不开启，可以使用update()方法更新。
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        // 自动切换
        autoplay: {
          // 自动切换的时间间隔
          delay: 3000,
          // 如果设置为true，当切换到最后一个slide时停止自动切换
          stopOnLastSlide: false,
          // 用户操作swiper之后，是否禁止autoplay。默认为true：停止
          disableOnInteraction: false
        },
        // 类似于苹果将多首歌曲的封面以3D界面的形式显示出来的方式
        coverflowEffect: {
          // slide做3d旋转时Y轴的旋转角度
          rotate: 0,
          // 每个slide之间的拉伸值，越大slide靠得越紧。5.3.6 后可使用%百分比
          stretch: -50,
          // slide的位置深度。值越大z轴距离越远，看起来越小。
          depth: 400,
          // depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。
          modifier: 1,
          // 是否开启slide阴影
          slideShadows: true
        },
        pagination: {
          el: `${el}-pagination`
        },
        on: {
          click: (e) => {
            if (!e.target.dataset.disabled) {
              this.$router.push({ path: e.target.dataset.path })
            }
          }
        }
      })
    }
  },
  destroyed () {
    this.mySwiper1 = null
    this.mySwiper2 = null
  }
}
</script>

<style lang="less">
@import "~@/styles/m/products.less";
@import "~@/styles/animate.less";
.m {
  .innovative.intracardiac {
    .innovative-advantages {
      .innovative-advantages-box {
      }
      .innovative-advantages-item {
        padding-bottom: 50px;
        color: #333333;
        .innovative-advantages-item-box {
          &.en {
            width: 140px;
          }
        }
        .innovative-advantages-item-img {
          width: 76px;
        }
        .innovative-advantages-item-title {
          font-weight: 600;
          padding-top: 6px;
        }
      }
    }
    .innovative-intelligence {
      .innovative-intelligence-imgbox {
        position: relative;
        height: 700px;
        background: linear-gradient(108deg, #19A8EB 0%, #407FED 100%);
        padding: 0 15%;
      }
      .innovative-intelligence-img {
        width: 100%;
        position: relative;
        z-index: 2;
      }
      .innovative-intelligence-rotate {
        max-width: none;
        width: 78%;
        position: absolute;
        top: 8%;
        left: 11%;
        animation: refresh-rotate infinite 5s linear;
      }
    }
    .innovative-structureFunction {
      position: relative;
      .innovative-structureFunction-rotate {
        width: 47%;
        position: absolute;
        top: 12.8%;
        left: 25.1%;
        animation: refresh-rotate 10s linear infinite;
      }
      .innovative-structureFunction-img {
        max-width: none;
        width: 100%;
        z-index: 2;
        position: relative;
        // top: -6%;
        // left: -6%;
      }
    }
  }
}
</style>
